import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsItem {
  id: string;
  name: string;
  productIds: string[];
}

const useGetFieldAlyticsItems = (options?: QueryOptions<FieldAlyticsItem[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrEmployeeQuery<FieldAlyticsItem[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/items` },
    { ...options, rewriteToEmployeeApi: false }
  );
}

export default useGetFieldAlyticsItems;
